import React from "react";
import { useSiteData } from "../lib/hooks";
import { fileUrl } from "../lib/api";
import { Reveal, Overline } from "../components/site/Reveal";
import PageHeader from "../components/site/PageHeader";
import EnquiryForm from "../components/site/EnquiryForm";
import { Briefcase, Clock, Package, Users } from "lucide-react";

const IMG = (s, k) => fileUrl(s?.images?.[k]);

export default function Corporate() {
  const s = useSiteData();
  const features = [
    [Briefcase, "Corporate Dining", "Meetings, conferences, training programs and office events."],
    [Clock, "Recurring Meals", "Daily and weekly meal programmes for teams and institutions."],
    [Package, "Packed & Bulk", "Boxed meals and large-volume food, delivered on time."],
    [Users, "Employee Meals", "Consistent, hygienic canteen and workforce catering."],
  ];
  return (
    <div>
      <PageHeader overline="Corporate & Food Services" title={<>Food that works around <span className="italic gold-text">your business.</span></>}
        subtitle="Reliable, scalable and consistent food programmes — from a single conference to daily meals for hundreds." image={IMG(s, "corporate")} />

      <section className="py-24 bg-charcoal text-ivory">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map(([Icon, t, d], i) => (
              <Reveal key={t} delay={(i % 4) * 0.08}>
                <div className="border border-gold/20 rounded-2xl p-7 h-full hover:bg-espresso transition-colors">
                  <span className="inline-flex w-12 h-12 rounded-full border border-gold/40 items-center justify-center mb-5"><Icon className="w-5 h-5 text-gold" /></span>
                  <h3 className="font-serif text-2xl mb-2">{t}</h3>
                  <p className="text-ivory/60 text-sm leading-relaxed">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-ivory">
        <div className="max-w-[1100px] mx-auto px-4 sm:px-8">
          <Reveal className="text-center mb-12">
            <Overline className="justify-center">Discuss Your Requirement</Overline>
            <h2 className="font-serif text-burgundy text-4xl sm:text-5xl mt-4">Tell us what your business needs.</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="bg-cream border border-gold/20 rounded-3xl p-6 sm:p-10">
              <EnquiryForm preset={{ category: "CORPORATE FOOD ENQUIRY", event_type: "Corporate", service_type: "Corporate Meals" }} />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
